import React from "react";
import { useToast } from "@/hooks/use-toast";
import ItemQuantitySection from "./form/ItemQuantitySection";
import ItemAttributesSection from "./form/ItemAttributesSection";
import { useItemForm } from "./hooks/useItemForm";
import ActionButtons from "./form/ActionButtons";
import { EditItemFormProps } from "./EditItemForm.d";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const EditItemForm = ({ item, onOpenChange, onItemUpdate, style, listId, scrollRef }: EditItemFormProps) => {

  const { toast } = useToast();

  const {
    quantity,
    setQuantity,
    unit,
    setUnit,
    attributes,
    isSubmitting,
    quantityPresets,
    productAttributes,
    handleSubmit,
    handleDeleteItem,
    handleQuantitySelect,
    handleAddAttribute,
    handleRemoveAttribute
  } = useItemForm({
    item,
    onOpenChange,
    onItemUpdate,
    toast,
    listId
  });

  return (
    <form
      onSubmit={handleSubmit}
      className="pt-4 flex flex-col h-full overflow-y-auto"
      style={style}
    >
      <Tabs defaultValue="quantita" className="flex-1 flex flex-col">
        <TabsList className="grid grid-cols-2">
          <TabsTrigger value="quantita">Quantità</TabsTrigger>
          <TabsTrigger value="attributi">Attributi</TabsTrigger>
        </TabsList>
        <TabsContent value="quantita" className="space-y-4 overflow-y-auto pt-4">
          <ItemQuantitySection
            quantity={quantity}
            setQuantity={setQuantity}
            quantityPresets={quantityPresets}
            onQuantitySelect={handleQuantitySelect}
            unit={unit}
            setUnit={setUnit}
          />
        </TabsContent>
        <TabsContent value="attributi" className="space-y-4 overflow-y-auto pt-4">
          <ItemAttributesSection
            attributes={attributes}
            onAttributeAdd={handleAddAttribute}
            onAttributeRemove={handleRemoveAttribute}
            suggestedAttributes={productAttributes}
          />
        </TabsContent>
      </Tabs>
      <ActionButtons
        onOpenChange={onOpenChange}
        onDeleteItem={handleDeleteItem}
        isSubmitting={isSubmitting}
      />
    </form>
  );
};

export default EditItemForm;
